import amplitude from "../Amplitude";

export const setAmplitudeIdentifyProperties = (properties) => {
  try {
    const identifyEvent = new amplitude.Identify();

    // Loop over all property key/value pairs and set them
    Object.entries(properties).forEach(([key, value]) => {
      identifyEvent.set(key, value);
    });

    amplitude.identify(identifyEvent);
  } catch (error) {
    console.error("Error while setting amplitude properties", error);
  }
};

export const setAmplitudeUserId = (userId) => amplitude.setUserId(userId);
